import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { maskString } from 'utils/functions'
import { Tooltip } from '@mui/material'
import { CheckCircle, Cancel, ImageSearch, Info, WarningRounded } from '@mui/icons-material'
import Colors from 'utils/Colors'
import { Button, Modal } from 'components'
import { get } from 'services/api'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import LoadingSplash from 'components/LoadingSplash'
import ProspectDetails from 'components/ProspectDetails'

import BuildFlow from './BuildFlow'
import styles from './styles'

function DashboardTable(props) {
  const { tableData } = props
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(false)
  const [currentRequest, setCurrentRequest] = useState(null)
  const [showModal, setShowModal] = useState(false)

  function returnFinishedComponent(isFinished, isExpired) {
    const iconStyle = isFinished
      ? isExpired
        ? { color: Colors.orange }
        : { color: Colors.green }
      : { color: Colors.gray }

    return isFinished ? (
      isExpired ? <WarningRounded style={iconStyle} /> : <CheckCircle style={iconStyle} />
    ) : (
      <Info style={iconStyle} />
    )
  }

  function returnApprovedComponent(approved, finished) {
    if (!finished) return <Info style={{ color: Colors.gray }} />
    return finished && approved ? (
      <CheckCircle style={{ color: Colors.green }} />
    ) : (
      <Cancel style={{ color: Colors.red }} />
    )
  }

  async function handleShowRequest(item) {
    setLoading(true)
    setShowModal(true)
    get({
      url: `/antifraude/request`,
      token,
      params: {
        _id: item.id,
      },
    })
      .then((response) => {
        setCurrentRequest(response.data)
      })
      .catch(() => {
        toast.error('Erro ao carregar informações da solicitação')
        setShowModal(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div>
      <table className={classes.table}>
        <thead>
        <tr>
          <th colSpan={1}>Solicitação</th>
          <th colSpan={1}>Dados</th>
          <th colSpan={3}>Validação</th>
          <th colSpan={1}>Imagens</th>
          <th colSpan={1}>Finalizado</th>
          <th colSpan={1}>Aprovado</th>
        </tr>
        </thead>
        <tbody>
        {tableData.length === 0 && (
          <tr key="-1">
            <td colSpan={8}>Nenhum registro encontrado.</td>
          </tr>
        )}
        {tableData.map((item) => {
          const showButton =
            item.status_face?.liveness_attempts > 0 ||
            item.status_document?.ocr_attempts > 0
          return (
            <tr key={item.id}>
              <td colSpan={1}>
                {item.id}
                <br />
                {item.created_at}
              </td>
              <td colSpan={1}>
                <div className="align-left">
                  <strong>Nome: </strong>
                  {item.name}
                  <br />
                  <strong>CPF: </strong>
                  {maskString(item.cpf, 'cpf')}
                  <br />
                  <strong>Telefone: </strong>
                  {maskString(item.phone, 'phone')}
                  <br />
                  <strong>E-mail: </strong>
                  {item.email}
                  <br />
                </div>
              </td>
              <td colSpan={3}>
                <div>
                  {item ? (
                    <div className={classes.column}>
                      <BuildFlow item={item} />
                    </div>
                  ) : null}
                </div>
              </td>

              <td colSpan={1}>
                {showButton ? (
                  <Tooltip title="Visualizar documento de identidade e selfie">
                      <span>
                        <Button onClick={() => handleShowRequest(item)}>
                          <span>
                            <ImageSearch fontSize="small" />
                          </span>
                          <span>Exibir imagens</span>
                        </Button>
                      </span>
                  </Tooltip>
                ) : null}
              </td>

              <td colSpan={1} className="centery">
                <div className="item-column">
                  {returnFinishedComponent(item.finished, item.expired)}
                  {item.expired === true && (
                    <span>
                        Expirado
                      </span>
                  )}
                </div>
              </td>

              <td colSpan={1} className="centery divs">
                <div
                  style={{ maxWidth: 130, margin: '0 auto' }}
                  className="item-column"
                >
                  {returnApprovedComponent(item.approved, item.finished)}
                </div>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>
      <Modal
        open={showModal}
        onClose={() => {
          setCurrentRequest(null)
          setShowModal(false)
        }}
        title="Imagens do candidato"
      >
        {loading ? (
          <LoadingSplash loadingText="Carregando dados do assessor. Por favor, aguarde." />
        ) : (
          <div className={classes.modalRoot}>
            <ProspectDetails info={currentRequest} />
          </div>
        )}
      </Modal>
    </div>
  )
}

DashboardTable.propTypes = {
  tableData: PropTypes.array.isRequired,
}

export default DashboardTable
